
// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import SPA from "./layouts/SPA"; // your current Header + Sidebar + Toc + Footer
// import ContactPage from "./components/ContactNow/ContactNow.jsx";
// import DemoPage from "./pages/demoPage.jsx";
// import BookDemo from "./components/bookDemo/BookDemo.jsx"
// import './styles/global.css';

// function App() {
//   return (
//     <Routes>
//       {/* Main SPA layout */}
//       <Route path="/" element={<SPA />} />

//       {/* Contact page - completely separate */}
//       <Route path="/contact" element={<ContactPage />} />
//       <Route path="/demo" element={<DemoPage />} />
//       <Route path="/bookdemo" element={<BookDemo/>} />
//     </Routes>
//   );
// }

// export default App;

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom"; // <-- add Navigate
import SPA from "./layouts/SPA";
import ContactPage from "./components/ContactNow/ContactNow.jsx";
import DemoPage from "./pages/demoPage.jsx";
import BookDemo from "./components/bookDemo/BookDemo.jsx"
import UseCases from "./components/Usecases/UsecasesAPM.jsx";
import UseCases1 from "./components/Usecases/UsecasesLH.jsx";
import './styles/global.css';

function App() {
  return (
    <Routes>
      {/* Redirect root / to default section */}
      <Route path="/" element={<Navigate to="/exploreNetraa" replace />} />

      {/* SPA with dynamic section */}
      <Route path="/:section" element={<SPA />} />

      {/* Other standalone pages */}
      <Route path="/usecasesAPM" element={<UseCases />} />
      <Route path="/usecasesLH" element={<UseCases1 />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/bookdemo" element={<BookDemo />} />
    </Routes>
  );
}

export default App;